export default "__VITE_ASSET__bb4072ce__"